import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { BankEnum } from '@zaoblako/web/core/models/enums/bank.enum';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';

@Component({
  selector: 'crm-welcome-system-select-bank',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './welcome-system-select-bank.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WelcomeSystemSelectBankComponent {
  @Output() public selectBank = new EventEmitter<BankEnum>();

  public get BankEnum() {
    return BankEnum;
  }
}
